
import {white, blue600} from 'material-ui/styles/colors';
const styles = {
    rightIcon: {
        position: 'absolute',
        right: 50
    },
    rightVisibleIcon: {
        position: 'absolute',
        right: 10,
    },
    dropdown: {
        position: 'absolute',
        right: 50,
        height: 48,
        color: white,
        fontSize: 14,
        backgroundColor: blue600
    }
};

export default styles;



// WEBPACK FOOTER //
// src/components/news/NewsInfo.css.js